import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";
import Constants from "../../legalViews/common/Constants";

export default class AddLegalViewTypeIndexCategoriesInteractor {
  private createListResource: CreateListResourceInteractor<IDocumentTypeIndexCategory>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(
    organisationLegalViewTypeList: IDocumentTypeIndexCategory[],
    legalViewTypeId: number,
    organisationId: number
  ) {
    return this.createListResource.execute(
      `${Constants.legalViewTypesPath}/${legalViewTypeId}/organisations/${organisationId}`,
      organisationLegalViewTypeList,
      undefined,
      DocumentTypeIndexCategoryParamMapper
    );
  }
}
